import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import api from "@/lib/api";
import { msgErroreFile, ErroreFileBox } from "@/components/ConflittoNome";
import { X, ZoomIn, ZoomOut, Download } from "lucide-react";

export default function DocLightbox({ file, onClose }) {
  const [url, setUrl] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [err, setErr] = useState(null);
  const name = file.original_filename || "documento";
  const isImg = /\.(jpg|jpeg|png|webp|heic|heif|gif)$/i.test(name) || (file.content_type || "").startsWith("image/");
  const isPdf = /\.pdf$/i.test(name) || (file.content_type || "") === "application/pdf";
  useEffect(() => {
    let active = true; let obj;
    api.get(`/files/${file.id}/download`, { responseType: "blob" }).then((r) => { if (!active) return; obj = URL.createObjectURL(r.data); setUrl(obj); })
      .catch(async (e) => { const m = await msgErroreFile(e); if (active) setErr(m); });
    return () => { active = false; if (obj) URL.revokeObjectURL(obj); };
  }, [file.id]); // eslint-disable-line

  const dl = () => { if (!url) return; const a = document.createElement("a"); a.href = url; a.download = name; a.click(); };

  return createPortal(
    <div className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex flex-col" data-testid="doc-lightbox">
      <div className="flex items-center justify-between px-4 py-3 text-white shrink-0">
        <span className="text-sm font-medium truncate">{name}</span>
        <div className="flex items-center gap-1.5">
          {isImg && (<>
            <button data-testid="lightbox-zoom-out" onClick={() => setZoom((z) => Math.max(1, z - 0.25))} className="p-2 rounded-lg hover:bg-white/10"><ZoomOut size={18} /></button>
            <span className="text-xs w-10 text-center">{Math.round(zoom * 100)}%</span>
            <button data-testid="lightbox-zoom-in" onClick={() => setZoom((z) => Math.min(4, z + 0.25))} className="p-2 rounded-lg hover:bg-white/10"><ZoomIn size={18} /></button>
          </>)}
          <button data-testid="lightbox-download" onClick={dl} className="p-2 rounded-lg hover:bg-white/10"><Download size={18} /></button>
          <button data-testid="lightbox-close" onClick={onClose} className="p-2 rounded-lg hover:bg-white/10"><X size={20} /></button>
        </div>
      </div>
      <div className="flex-1 overflow-auto flex items-center justify-center p-4" onClick={onClose}>
        {err ? <ErroreFileBox msg={err} onClose={onClose} dark /> :
         !url ? <div className="text-white/70 text-sm">Caricamento…</div> :
         isImg ? <img src={url} alt={name} onClick={(e) => e.stopPropagation()} onError={() => setErr("Impossibile mostrare l'immagine: il file potrebbe essere danneggiato.")} style={{ transform: `scale(${zoom})` }} className="max-w-full max-h-full object-contain transition-transform cursor-zoom-in" /> :
         isPdf ? <iframe title="documento" src={url} onClick={(e) => e.stopPropagation()} className="w-full h-full bg-white rounded-lg" style={{ minHeight: "80vh" }} /> :
         <div className="text-white/80 text-sm text-center">Anteprima non disponibile per questo formato.<br /><button onClick={dl} className="underline mt-2">Scarica il file</button></div>}
      </div>
    </div>,
    document.body
  );
}
